import React, {useState} from 'react'
import { Button, Modal } from 'antd'
import {
    EnableOrDisableServiceWarningIcon,
    ModalCloseIco,
    ModalErrorIco,
    ModalSuccessIco
} from '../../../modules/CustomIcons'

import './index.scss'
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import { useTranslation } from 'react-i18next';

const EnableOrDisableServiceModal: React.FC<any> = (props : any) => {
    const {t} = useTranslation()
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const onClose = () => {
        props.onClose((old_value) => false)
        setShowSuccessModal(old_data => false)
    }

    const activateService = () => {
        setShowSuccessModal(old_data => true)
    }

    let activateBtnText=props.serviceType ==='activate' ? t("businessCards.activate") : t("businessCards.deactivate");

    if (props.activateBtnText){
        activateBtnText=props.activateBtnText;
    }

  return (
    <>
        {
            !showSuccessModal && <Modal
                title={props.modalTitle}
                closeIcon={<ModalCloseIco />}
                centered
                visible={props.visible}
                onCancel={onClose}
                width={props.width || 580}
                className={`enable_or_disable_service_modal manage_faster_menus  no_footer  ${props?.className}`}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
            >

                <div className={'full flex align_center justify_center direction_column enable_or_disable_service_body'}>
                    <EnableOrDisableServiceWarningIcon />

                    <p>{props.modalText}</p>

                    <div className='flex btn_groups justify_center align_center'>
                        <Button type="button" className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center" onClick={onClose} >{t("common.cancel")}</Button>
                        <Button type="button" className="blue-button next_btn btn flex align_center justify_center" onClick={activateService} >{activateBtnText}</Button>
                    </div>
                </div>

            </Modal>
        }

        {
            showSuccessModal && <SuccessOrErrorModal
                visible={showSuccessModal}
                onCancel={onClose}
                modalType={'success'}
                modalTitle={props.successModalTitle}
                modalText={props.successModalText}
                className={'template_update_success'}
                width={380}
                modalFooter={true}
            />
        }
    </>
  )
}

export default EnableOrDisableServiceModal
